import { memo } from "react";
import { Link } from "react-router-dom";
import { LogoFull } from "../../assets/icons/logoFull";
import { NavigationMenu } from "./NavigationMenu";
import { ExtensionBanner } from "../Banners/ExtensionBanner";
import { useSidebar } from "../../context/SidebarContext";

export const Sidebar = memo(() => {
  const extensionInstalled =
    localStorage.getItem("extensionInstalled") === "true";
  const { collapsed, isResizing, startResize, collapse } = useSidebar();

  return (
    <aside
      className={`sidebar nav-menu d-none d-lg-block h-100 position-fixed top-0 bottom-0${
        collapsed ? " sidebar--collapsed" : ""
      }${isResizing ? " sidebar--resizing" : ""}`}
    >
      <div className="h-100 d-flex flex-column">
        <div className="d-flex flex-column p-3 flex-grow-1 overflow-y-auto">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <Link
              to="/"
              className="d-flex align-items-center link-body-emphasis text-decoration-none ps-1"
            >
              <LogoFull width="150" height="33" />
            </Link>

            <button
              type="button"
              className="sidebar-collapse-btn btn btn-none p-1 d-flex align-items-center text-secondary flex-shrink-0"
              onClick={collapse}
              aria-label="Collapse sidebar"
              title="Collapse sidebar"
            >
              <i className="bi bi-chevron-double-left" aria-hidden="true"></i>
            </button>
          </div>

          <NavigationMenu />
        </div>

        {!extensionInstalled && <ExtensionBanner />}
      </div>

      {/* Drag the right edge to resize; dragging below the minimum collapses. */}
      <div
        className="sidebar-resize-handle"
        onMouseDown={startResize}
        onTouchStart={startResize}
        role="separator"
        aria-orientation="vertical"
        aria-label="Resize sidebar"
      />
    </aside>
  );
});
